import React, { Component } from 'react'
import { Icon, List, WingBlank, WhiteSpace, Button, Radio, Pagination, Toast } from 'antd-mobile'
import axios from "../../../service/axios";
import NoneDatas from "../../../components/noneDatas";
const RadioItem = Radio.RadioItem

export class DefaultGroupList extends Component {
  state = {
    pageTotalNum: 0,
    pageNo: 1,
    groupList: [],
    gid: '',
  };

  componentWillMount() {
    const { uids } = this.props;
    if (uids && uids.length > 0) {
      this.getGroupList(1);
    }
  }

  onChange = gid => {
    console.log(gid);
    this.setState({
      gid,
    });
  }
  onPageChange(e) {
    const { pageTotalNum } = this.state;
    e = e > pageTotalNum ? pageTotalNum : e;
    this.getGroupList(e);
    this.setState({
      selectNum: 0,
      selectGids: [],
    });
  }
  getGroupList(e) {
    axios.post("/api/group/list", {
      page: {
        pageNo: e,
        pageSize: 10,
      },
    }).then(res => {
      if (res && res.status == 200 && res.data) {
        if (res.data.resultList) {
          this.setState({
            groupList: res.data.resultList,
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.totalCount / 10),
          });
        } else {
          this.setState({
            groupList: [],
            pageNo: res.data.pageNo,
            pageTotalNum: Math.ceil(res.data.totalCount / 10),
          });
        }
      }
    });
  }
  onSave() {
    const { uids } = this.props;
    console.log(uids, this.state.gid);
    axios.post("/api/user/ptt/updateDefaultGroup", {
      defaultGroupGid: this.state.gid,
      uids,
    }).then(res => {
      if (res && res.status == 200) {
        Toast.success(res.message, 2, () => {
          window.location.reload();
        });
      } else {
        Toast.fail(res.message);
      }
    });
  }

  render() {
    const { pageTotalNum, pageNo, groupList, gid } = this.state
    const { handleChildClose, } = this.props
    return (
      <div className="selected-container">
        <List renderHeader={() => '请选择默认群组'}>
          {groupList.map((i, index) => (
            <RadioItem
              key={index}
              checked={gid === i.gid}
              extra={<Icon type="cross" />}
              onChange={() => this.onChange(i.gid)}
            >
              {i.name}
            </RadioItem>
          ))}
          <WingBlank>
            {pageTotalNum > 0 ? (
              <Pagination
                total={pageTotalNum}
                current={pageNo}
                locale={{
                  prevText: "上一页",
                  nextText: "下一页",
                }}
                onChange={e => this.onPageChange(e)}
              />
            ) : (
                ""
              )}
          </WingBlank>
          {groupList.length == 0 ? <NoneDatas /> : ""}
          <WingBlank>
            <WhiteSpace size="xl" />
            <Button type="primary" onClick={() => this.onSave()}>
              确定
            </Button>
            <WhiteSpace size="xl" />
            <Button type="" onClick={() => handleChildClose()}>
              返回
            </Button>
            <WhiteSpace size="xl" />
          </WingBlank>
        </List>
      </div>
    )
  }
}

export default DefaultGroupList
